import React from "react";
import { useController } from "react-hook-form";
import PhoneInputWithCountry from "react-phone-number-input/react-hook-form";

import { CustomPhoneInputProps } from "@models/components/formElements.model";

import "react-phone-number-input/style.css";

const CustomPhoneInput: React.FC<CustomPhoneInputProps> = ({
  className,
  control,
  errors,
  id,
  label,
  name,
  placeholder,
  registerOptions,
  ...rest
}) => {
  const {
    field: { ...inputProps },
  } = useController({
    control,
    defaultValue: "",
    name,
    rules: { ...registerOptions[name] },
  });

  return (
    <>
      <PhoneInputWithCountry
        {...inputProps}
        className={className}
        control={control}
        countryOptionsOrder={["CH", "DE", "AT", "LI", "..."]}
        international
        defaultCountry="CH"
        addInternationalOption={false}
        placeholder={placeholder ?? label}
        {...rest}
      />
      <label htmlFor={name}>
        {label}
        {registerOptions[name]?.required ? "*" : ""}
      </label>
      {errors[name] && (
        <div className="invalid-feedback">{errors[name].message}</div>
      )}
    </>
  );
};

export default CustomPhoneInput;
